import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type { RecordConfigPayload, RecordConfigResponse } from '../model/record-config.types';

export async function getRecordConfig(matrixId: number): Promise<RecordConfigResponse> {
  const response = await api.get<ApiResponse<RecordConfigResponse>>(
    `/matrices/${matrixId}/config`
  );
  return response.data.data!;
}

export async function updateRecordConfig(
  matrixId: number,
  payload: RecordConfigPayload
): Promise<void> {
  await api.put(`/matrices/${matrixId}/config`, payload);
}
